module.exports = __webpack_public_path__ + "static/logo-brand-white-dcfa11addb13da94ffa16d02186dc620.svg";